import { useState } from 'react';
import { Form, Button, InputGroup, Card, Table } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';

const CotisationModif = ({ closeModal, getCotisations, data, cotisations }) => {
    const [formData, setFormData] = useState(data);

    const [showMontantTribu, setShowMontantTribu] = useState(false);
    const [showMontantSiv, setShowMontantSiv] = useState(false);

    const url = localStorage.getItem('url');

    const handleToggle = (field) => {
        setFormData({ ...formData, [field]: formData[field] === 1 ? 0 : 1 });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Envoi des données via Fetch POST
        fetch(`${url}UpdateCotisation/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('Réponse du serveur :', data);
                // Traitez la réponse du serveur si nécessaire
                getCotisations();
                closeModal();
            })
            .catch((error) => {
                console.error('Erreur:', error);
            });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon_reference">Feuille</InputGroup.Text>
                <Form.Control
                    type="text"
                    name="reference"
                    value={formData.reference}
                    onChange={handleChange}
                />
            </InputGroup>

            <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon_titre">Titre</InputGroup.Text>
                <Form.Control
                    type="text"
                    name="titre"
                    value={formData.titre}
                    onChange={handleChange}
                />
            </InputGroup>

            <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon_libelle">Libellé bloc cotisation</InputGroup.Text>
                <Form.Control
                    type="text"
                    name="libelle"
                    value={formData.libelle}
                    onChange={handleChange}
                />
            </InputGroup>

            {/* <InputGroup className="mb-3" style={{ width: '100%' }}>
                <InputGroup.Text id="basic-addon_libelle">Cotisation</InputGroup.Text>
                <Form.Select
                    variant="outline-secondary"
                    name="cotisation_id"
                    value={formData.cotisation_id}
                    onChange={handleChange}
                    aria-label="Libelle"
                >
                    {cotisations.map((e) => (
                        <option key={e.libelle} value={e.id}>
                            {e.reference}
                        </option>
                    ))}
                </Form.Select>
                <Button variant="outline-secondary" id="button-addon1" onClick={() => setShowMontant(!showMontant)}>
                    <FaEye />
                </Button>
            </InputGroup>
            {showMontant && <>
                <Card>
                    <Card.Header>Choix de cotisation</Card.Header>
                    <Table striped bordered hover style={{ margin: 'auto', }}>
                        <thead>
                            <tr>
                                <th>Libelle</th>
                                <th>Montant</th>
                                {formData.trois_fois === 1 && <th>En 3 fois</th>}
                                {formData.six_fois === 1 && <th>En 6 fois</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                choixFiltered.map((e) => (
                                    <tr>
                                        <td>{e.libelle}</td>
                                        <td>{e.montant}&nbsp;€</td>
                                        {formData.trois_fois === 1 && <td>{Math.ceil(e.montant / 3)}&nbsp;€</td>}
                                        {formData.six_fois === 1 && <td>{Math.ceil(e.montant / 6)}&nbsp;€</td>}
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                </Card>
                <br />
            </>
            } */}

            <InputGroup className="mb-3" style={{ width: '100%' }}>
                <InputGroup.Text id="basic-addon_trois_fois">Trois Fois</InputGroup.Text>
                <Button
                    variant={formData.trois_fois === 1 ? 'success' : 'danger'}
                    onClick={() => handleToggle('trois_fois')}
                >
                    {formData.trois_fois ? 'Oui' : 'Non'}
                </Button>

                <InputGroup.Text id="basic-addon_six_fois">Six Fois</InputGroup.Text>
                <Button
                    variant={formData.six_fois === 1 ? 'success' : 'danger'}
                    onClick={() => handleToggle('six_fois')}
                >
                    {formData.six_fois ? 'Oui' : 'Non'}
                </Button>
            </InputGroup>

            <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon_tribu_montant">Montant Tribu</InputGroup.Text>
                <Form.Control
                    type="number"
                    name="tribu_montant"
                    value={formData.tribu_montant}
                    onChange={handleChange}
                />
                {
                    (formData.six_fois || formData.trois_fois) &&
                    <Button variant="outline-secondary" id="button-addon1" onClick={() => setShowMontantTribu(!showMontantTribu)}>
                        <FaEye />
                    </Button>
                }
            </InputGroup>

            {showMontantTribu && (<>
                <Card>
                    <Card.Header>Montant tribu</Card.Header>
                    {/* <Card.Body> */}
                    <Table striped bordered hover style={{ margin: 'auto', }}>
                        <thead>
                            <tr>
                                <th>Montant</th>
                                {formData.trois_fois === 1 && <th>En 3 fois</th>}
                                {formData.six_fois === 1 && <th>En 6 fois</th>}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formData.tribu_montant}&nbsp;€</td>
                                {formData.trois_fois === 1 && <td>{formData.tribu_montant / 3}&nbsp;€</td>}
                                {formData.six_fois === 1 && <td>{formData.tribu_montant / 6}&nbsp;€</td>}
                            </tr>
                        </tbody>
                    </Table>
                </Card>
            </>)}

            <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon_siv_montant">Montant SIV</InputGroup.Text>
                <Form.Control
                    type="number"
                    name="siv_montant"
                    value={formData.siv_montant}
                    onChange={handleChange}
                />
                {
                    (formData.six_fois || formData.trois_fois) &&
                    <Button variant="outline-secondary" id="button-addon2" onClick={() => setShowMontantSiv(!showMontantSiv)}>
                        <FaEye />
                    </Button>
                }
            </InputGroup>

            {showMontantSiv && (<>
                <Card>
                    <Card.Header>Montant SIV</Card.Header>
                    {/* <Card.Body> */}
                    <Table striped bordered hover style={{ margin: 'auto', }}>
                        <thead>
                            <tr>
                                <th>Montant</th>
                                {formData.trois_fois === 1 && <th>En 3 fois</th>}
                                {formData.six_fois === 1 && <th>En 6 fois</th>}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formData.siv_montant}&nbsp;€</td>
                                {formData.trois_fois === 1 && <td>{formData.siv_montant / 3}&nbsp;€</td>}
                                {formData.six_fois === 1 && <td>{formData.siv_montant / 6}&nbsp;€</td>}
                            </tr>
                        </tbody>
                    </Table>
                </Card>
            </>)}

            <InputGroup className="mb-3">
                <InputGroup.Text>Feuille parent</InputGroup.Text>
                <Form.Select
                    type="text"
                    name="parent"
                    value={formData.parent}
                    onChange={handleChange}
                    // onChange={(e) => handleInputChange(field, e.target.value)}
                >
                    <option value='0'>Ceci est une feuille parent</option>
                    {cotisations.map((item, index) => (
                        <option key={index} value={item.id}>{item.reference}</option>
                    ))}
                </Form.Select>
            </InputGroup>

            {/* <Form.Group controlId="tribu_trois_fois">
                <Form.Label>tribu_Trois Fois</Form.Label>
                <Button
                    variant={formData.tribu_trois_fois === 1 ? 'success' : 'danger'}
                    onClick={() => handleToggle('tribu_trois_fois')}
                >
                    {formData.tribu_trois_fois ? 'Oui' : 'Non'}
                </Button>
            </Form.Group>
            <Form.Group controlId="tribu_six_fois">
                <Form.Label>Tribu Six Fois</Form.Label>
                <Button
                    variant={formData.tribu_six_fois === 1 ? 'success' : 'danger'}
                    onClick={() => handleToggle('tribu_six_fois')}
                >
                    {formData.tribu_six_fois ? 'Oui' : 'Non'}
                </Button>
            </Form.Group>

            <Form.Group controlId="prelevement_trois_fois">
                <Form.Label>Prélèvement Trois Fois</Form.Label>
                <Button
                    variant={formData.prelevement_trois_fois === 1 ? 'success' : 'danger'}
                    onClick={() => handleToggle('prelevement_trois_fois')}
                >
                    {formData.prelevement_trois_fois ? 'Oui' : 'Non'}
                </Button>
            </Form.Group>
            <Form.Group controlId="prelevement_six_fois">
                <Form.Label>Prélèvement Six Fois</Form.Label>
                <Button
                    variant={formData.prelevement_six_fois === 1 ? 'success' : 'danger'}
                    onClick={() => handleToggle('prelevement_six_fois')}
                >
                    {formData.prelevement_six_fois ? 'Oui' : 'Non'}
                </Button>
            </Form.Group> */}
            <Button variant="primary" type="submit">
                Modifier
            </Button>
        </Form>
    );
};

export default CotisationModif;
